import { EMPTY_LIST } from '../../../../constants/common'

export const QA_NAME_EDIT_BUILDINGS_GROUP_MODAL = 'editBuildingsGroup'

export const BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_BUILDING_GROUPS =
  'building_groups'

export const BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_UPDATE_MANAGERS =
  'perform_for_buildings'

export const EDIT_BUILDINGS_GROUP_FORM_INITIAL_VALUES = {
  [BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_BUILDING_GROUPS]: EMPTY_LIST,
  [BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_UPDATE_MANAGERS]: false,
}
